import { connect } from 'react-redux';
import { addLocaleData, IntlProvider } from 'react-intl';
import { locales } from 'acscp/translations';
import en from 'react-intl/locale-data/en';
import fr from 'react-intl/locale-data/fr';
import de from 'react-intl/locale-data/de';
import zh from 'react-intl/locale-data/zh';
import ru from 'react-intl/locale-data/ru';
import es from 'react-intl/locale-data/es';
import pt from 'react-intl/locale-data/pt';
import th from 'react-intl/locale-data/th';
import it from 'react-intl/locale-data/it';
import { AppState } from 'acscp/store';
import React from 'react';
import { PropsWithChildren } from 'react';

addLocaleData([...en]);
addLocaleData([...fr]);
addLocaleData([...de]);
addLocaleData([...zh]);
addLocaleData([...ru]);
addLocaleData([...es]);
addLocaleData([...pt]);
addLocaleData([...th]);
addLocaleData([...it]);

function mapStateToProps(state: AppState, ownProps: {}): IntlProvider.Props {
    return {
        locale: state.intl.locale,
        messages: locales[state.intl.locale],
    };
}

const DynamicIntlProvider: React.FC<IntlProvider.Props> = (props: PropsWithChildren<IntlProvider.Props>) => (
    <IntlProvider key={props.locale} {...props}>
        {props.children}
    </IntlProvider>
);

export const ConnectedIntlProvider = connect(mapStateToProps)(DynamicIntlProvider);
